import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { environment } from "src/environments/environment";
import { ValidatorService } from "../../validator/validator.service";

@Component({
  selector: "app-mu-form-dropdown",
  templateUrl: "./mu-form-dropdown.component.html",
  styleUrls: ["./mu-form-dropdown.component.sass"],
})
export class MuFormDropdownComponent<DataList> {
  @Input() formGroup: UntypedFormGroup;
  @Input() field: string;
  @Input() optionList: DataList[];
  @Input() filter: boolean;
  @Input() emptyFilterMessage: boolean;
  @Input() editableMask: boolean;
  @Input() positionTop: boolean;
  @Input() showClear: boolean = false;
  @Input() styleClass: string;
  @Input() filterBy: string = 'label';
  @Input() optionLabel: string = 'label';
  @Input() optionValue: string = 'value';
  constructor(
    public changeDetectorRef: ChangeDetectorRef,
    public validatorService: ValidatorService
  ) {
    /** */
  }

  /**
   * set position top
   */
  setPosition(): void {
    if (!this.positionTop || !this.optionList || this.optionList.length < 1) {
      return environment.guardClause;
    }
    setTimeout(() => {
      const element: HTMLElement = document.getElementsByClassName(
        "p-dropdown-panel"
      )[0] as HTMLElement;
      element.style.transformOrigin = "bottom";
      element.style.top = -1 * element.offsetHeight + "px";
      this.changeDetectorRef.detectChanges();
    });
  }
}
